import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: startDate => ({
        date: Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'itsmSummaryTickets',
        endpoint:           endpoints.itsm.summaryTickets,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => ({
            results: !response.results ? [] : response.results.map(item => ({
                lastUpdated:      item.last_updated,
                opened:           item.opened,
                descType:         item.desc_type,
                descUrgency:      item.desc_urgency,
                descImpact:       item.desc_impact,
                period:           item.period,
                descState:        item.desc_state,
                openedBy:         item.opened_by,
                idState:          item.state_id,
                resolutionTime:   item.resolution_time,
                idType:           item.type_id,
                closed:           item.closed,
                shortDescription: item.short_description,
                order_number:     item.order_number,
                responseTime:     item.response_time,
                idTicket:         item.ticket_id
            }))
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/itsmSummaryTickets.js